import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderStatusHistoryModel from "../../models/provider-status-history";

export default class ProviderStatusHistoryRepository extends BaseRepository {
  static modelClass = ProviderStatusHistoryModel;
  modelName = "provider-status-history";

  async query({ providerId, ...params } = {}) {
    if (!providerId) {
      throw new Error("providerId is required to fetch provider status history.");
    }

    const queryParams = qs.stringify({
      provider: providerId,
      ordering: "-updated_at",
      ...params,
    });

    return await super.query({
      urlPath: `provider_status_histories?${queryParams}`,
    });
  }
}
